import { useState } from "react";

const Slider = ({
    visible = true,
    className = "",
    title = "",
    defaultValue = 50,
    minValue = 0,
    maxValue = 100,
    step = 1,
    onChange = () => {},
    lazyUpdate = true,
    showIndicator = false,
    unit = "",
    disabled = false,
}) => {
    const [value, setValue] = useState(defaultValue);

    return (
        visible && (
            <div
                className={`flex h-6 w-60  items-center justify-between space-x-2 rounded-r5 bg-black70 px-2 opacity-80 transition-all hover:opacity-100 ${className} ${
                    disabled && "pointer-events-none"
                }`}
            >
                {title && <p className="text-h5">{title}</p>}
                <input
                    className="h-[.125rem] flex-grow-0 appearance-none bg-black40 outline-none"
                    type="range"
                    value={value}
                    min={minValue}
                    max={maxValue}
                    step={step}
                    onChange={(event) => {
                        let newValue = Number(event.target.value);
                        setValue(newValue);
                        if (!lazyUpdate) onChange(newValue);
                    }}
                    onMouseUp={(event) => {
                        if (lazyUpdate) onChange(Number(event.target.value));
                    }}
                    onTouchEnd={(event) => {
                        if (lazyUpdate) onChange(Number(event.target.value));
                    }}
                    disabled={disabled}
                />
                {showIndicator && (
                    <p className="text-h5 w-full text-right">
                        {value}
                        {unit}
                    </p>
                )}
            </div>
        )
    );
};

export default Slider;
